
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3 12a9 9 0 1118 0 9 9 0 01-18 0zm9-11C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm-.795 11.22c-.155.378-.233.886-.233 1.524h1.75l.027-.417c.05-.446.249-.836.595-1.169l.554-.526c.433-.42.736-.8.91-1.142.172-.346.259-.713.259-1.1 0-.852-.267-1.51-.8-1.976-.533-.47-1.283-.704-2.249-.704-.957 0-1.713.246-2.27.738-.55.493-.831 1.174-.84 2.044h1.982c.01-.364.114-.649.315-.854.205-.21.476-.315.813-.315.711 0 1.066.386 1.066 1.156 0 .255-.068.499-.205.731-.136.228-.412.526-.827.896-.41.364-.692.736-.847 1.114zm-.123 2.871a.995.995 0 00-.308.752c0 .3.1.55.3.745.206.196.475.294.807.294.333 0 .6-.098.8-.294a.987.987 0 00.308-.745.984.984 0 00-.315-.752c-.205-.2-.47-.3-.793-.3-.323 0-.59.1-.8.3z","fill":"#737373"}})])
          )
        }
      }
    